import Header from "./components/Header";
import Hero from "./components/Hero";
import EventFeed from "./components/EventFeed";
import Timeline from "./components/Timeline";
import Credibility from "./components/Credibility";
import Editorial from "./components/Editorial";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <EventFeed />
        <Timeline />
        <Credibility />
        <Editorial />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}